function initGeneralScripts() {
    $('.readmore_button').off('click.readmore').on('click.readmore', function (e) {
        e.preventDefault();
        $(this).parent('.readmore').toggleClass('show');
    });

    $('[data-bs-toggle="tooltip"]').each(function () {
        try {
            $(this).tooltip('dispose');
        } catch (e) {
            // Tooltip was not initialized yet.
        }
    });
    $('[data-bs-toggle="tooltip"]').tooltip();
}

function initDesktopMenuHover() {
    const $dropdown = $(".dropdown");
    const $dropdownToggle = $(".dropdown-toggle");
    const $dropdownMenu = $(".dropdown-menu");
    const $tabButton = $("#navbarNav .nav-link");
    const showClass = "show";

    if (!window.matchMedia("(min-width: 768px)").matches) {
        $dropdown.off("mouseenter.desktopMenu mouseleave.desktopMenu");
        $tabButton.off("mouseenter.desktopMenu");
        return;
    }

    $dropdown.off("mouseenter.desktopMenu mouseleave.desktopMenu").hover(
        function () {
            const $this = $(this);
            $this.addClass(showClass);
            $this.find($dropdownToggle).attr("aria-expanded", "true");
            $this.find($dropdownMenu).addClass(showClass);
        },
        function () {
            const $this = $(this);
            $this.removeClass(showClass);
            $this.find($dropdownToggle).attr("aria-expanded", "false");
            $this.find($dropdownMenu).removeClass(showClass);
        }
    );

    $tabButton.off("mouseenter.desktopMenu").on("mouseenter.desktopMenu", function () {
        $(this).click();
    });
}

function onPageReady() {
    initGeneralScripts();
    initDesktopMenuHover();
}

document.addEventListener("page:load", onPageReady);
$(window).off("resize.desktopMenu").on("resize.desktopMenu", initDesktopMenuHover);
